import { Link } from 'react-router-dom';
import { IconCheckCircle } from '../icons/Icons.jsx';

export const SEVERITY_COLOR = {
  critical: 'var(--danger)',
  warning: 'var(--warning)',
  info: 'var(--accent)',
  success: 'var(--success)',
};

// One row per problem; the stripe colour carries severity, the button carries the fix.
export function AttentionList({ items = [], onNavigate, emptyTitle = 'You are all caught up', emptyText = 'Nothing needs your attention right now.' }) {
  if (!items.length) {
    return (
      <div className="flex items-center gap-3 rounded-[10px] px-4 py-5" style={{ background: 'var(--successSoft)', color: 'var(--successSoftText)' }}>
        <IconCheckCircle size={22} />
        <div>
          <p className="text-sm font-bold">{emptyTitle}</p>
          <p className="text-xs opacity-90">{emptyText}</p>
        </div>
      </div>
    );
  }
  return (
    <ul className="grid gap-2">
      {items.map((item) => (
        <li
          key={item.id}
          className="grid grid-cols-[4px_minmax(0,1fr)_auto] items-center gap-3 overflow-hidden rounded-[10px] pr-3"
          style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
        >
          <span className="self-stretch" style={{ background: SEVERITY_COLOR[item.severity] || 'var(--accent)' }} />
          <div className="min-w-0 py-2.5">
            <p className="text-sm font-semibold leading-snug" style={{ color: 'var(--text)' }}>{item.title}</p>
            {item.detail && <p className="text-xs mt-0.5 leading-snug" style={{ color: 'var(--textMuted)' }}>{item.detail}</p>}
          </div>
          {item.action?.to && (
            <Link
              to={item.action.to}
              onClick={onNavigate}
              className="text-xs font-bold whitespace-nowrap rounded-[8px] px-2.5 py-1.5 transition-colors hover:bg-[var(--accentSoft)]"
              style={{ color: 'var(--accentHot)' }}
            >
              {item.action.label}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
}
